import {
  post,
  get,
  createCacheAjax,
  getStore,
  postStore,
} from '@/utils/http/http'
import {
  LIVE_GW_URL,
  MARKET_URL,
  BILL_API_URL,
  ZHIBO_URL,
  FIXUP_URL,
  WechatApp,
  SHOP_URL,
  LIVEPAY_URL,
  LIVE_PALY_URL,
  // HOMEMINIURI,
  homeminiToLiveGw,
  VZAN_STORE_BASE_URL,
  SCRM_URL,
  wxHost,
  LIVE_INTERFACE_URL,
} from '@/utils/http/baseUrl'
import qs from 'qs'
import { getToken } from '@/utils/utils'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import StoreApiController from '@/controllers/storeController/view/store/storeApi.controller.js'

const _getAgentSetting = createCacheAjax({
  requestType: 'post',
  timeout: 1000, // 1秒内多次调用只请求一次
})

const _getAgentAuth = createCacheAjax({
  requestType: 'get',
  timeout: 1000, // 1秒内多次调用只请求一次
})

export default {
  // 国科 获取消耗明细
  getGuoKeConsumptionDetails: data =>
    post(`${MARKET_URL}/api/v1/redpacket/getredpacketlistguoke`, data),
  // 代理员-申请
  agentSubmit: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentSubmit`, params, false),
  // 代理员-下载
  healthUserListExport: params =>
    post(
      `${LIVE_GW_URL}/datalive/v1/h5/user_manage/healthUserListExport`,
      params,
      false
    ),
  // 代理员-获取手机验证码
  getPhoneCode: params =>
    get(`${LIVE_GW_URL}/health/v1/h5/agent/getPhoneCode`, params, false),
  // 代理员-申请详情
  agentDetails: params => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    return $apiPost(
      `${LIVE_GW_URL}/health/v1/h5/agent/agentDetails`,
      params,
      false
    )
  },
  // 代理员-代理中心详情
  agentCenter: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentCenter`, params, false),
  // 代理员-代理中心详情-数据
  agentCenterData: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentCenterData`, params, false),
  // 代理员-代理中心话题列表(分页)
  agentCenterTopicList: params =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/agentCenterTopicList`,
      params,
      true,
      {
        allRes: true,
      }
    ),
  // 获取代理配置
  getAgentSetting: params => {
    const isStore = StoreController.isStore()
    let path = isStore
      ? '/health/v1/h5/store/manager/getAgentSetting'
      : '/health/v1/h5/agent/getAgentSetting'
    return _getAgentSetting(
      `${LIVE_GW_URL}${path}`,
      params,
      false,
      isStore ? StoreController.apiHeaderConfig() : {}
    )
  },
  /** 判断等级设置是否支持申请代理表单，true表示要支持 */
  checkLevelRecruitForm: params =>
    get(`${LIVE_GW_URL}/health/gray/checkLevelRecruitForm`, params, false),
  // 管理员-单个话题的代理员明细列表(分页-旧)
  agentDetailsList: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentDetailsList`, params, false),
  // 管理员-单个话题的代理员明细列表(分页-新)
  agentList: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentList`, params, false),
  // 代理员列表详情
  agentListDetail: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentListDetail`, params, false),
  // 管理员-查看代理员单个话题代理详情数量统计
  topicAgentDetails: params => {
    const isStore = StoreController.isStore()
    return isStore
      ? postStore(
          `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/topicAgentDetailsByStore`,
          params,
          false
        )
      : post(
          `${LIVE_GW_URL}/health/v1/h5/agent/topicAgentDetails`,
          params,
          false
        )
  },
  // postStore
  // 观众明细列表(分页)
  get_be_share_user_list: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/healthUserList`, params, false),
  // 获取开关配置
  topicSwitch: params =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/topicSwitch`, params, false),
  // 健康直播-判断是否为代理员
  getAgentShareAuth: data =>
    get(`${LIVE_GW_URL}/health/v1/h5/agent/agentShareAuth`, data, false),
  // 用户领取话题红包记录列表
  // redpacketRecieveList: data =>
  //   post(`${MARKET_URL}/api/v1/redpacket/redpacket_recieve_list`, data),
  // 每日趋势
  agentCenterTrend: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentCenterTrend`, data),
  // 代理推广推广直播数据-观众详情
  userAudDetail: data =>
    get(
      `${LIVE_GW_URL}/datalive/v1/h5/user_manage/healthAgentToUserAudDetail`,
      data
    ),
  // 观众详情-健康用户溯源
  userTrace: data =>
    post(`${LIVE_GW_URL}/datalive/v1/h5/user_manage/healthUserTrace`, data),
  // 观众详情-健康用户溯源
  tpAgentList: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/tpAgentList`, data, true, {
      allRes: 1,
    }),
  // 观众详情-健康用户溯源
  getTopicStatistics: (id, data) =>
    get(
      `${LIVE_GW_URL}/datalive/v1/h5/topic_data_statistics/overview/${id}`,
      data
    ),
  // 观众禁用/拉黑
  operateliveuser: data => {
    const storeId = StoreController.storeId()
    const isStore = StoreController.isStore()
    const params = isStore ? { ...data, storeId, from: 4 } : data
    const $apiPost = isStore ? postStore : post
    return $apiPost(`${MARKET_URL}/operateliveuserv2`, params)
  },
  // 代理员信息
  getAgentAuth: data => {
    const isStore = StoreController.isStore()
    // 门店系统进入的，使用一个默认的身份
    return isStore
      ? new Promise(resolve =>
          resolve({
            code: 0,
            isok: true,
            msg: '操作成功',
            dataObj: {
              isAgent: true,
              level: 3,
            },
          })
        )
      : _getAgentAuth(`${LIVE_GW_URL}/health/v1/h5/agent/agentAuth`, data)
  },
  // _getAgentAuth(`${LIVE_GW_URL}/health/v1/h5/agent/agentAuth`, data),
  // 审核代理员a
  changeAuditAgent: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/auditAgent`, data, false, {
      allRes: 1,
    }),
  // 获取代理等级
  getAgentLevelList: data =>
    get(`${LIVE_GW_URL}/health/v1/admin/agent/getAgentLevelList`, data),
  // 获取H5客户管理
  getCustomerManageInfo: data => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    const url = isStore
      ? `${LIVE_GW_URL}/health/v1/h5/store/manager/getStoreCustomerManageInfo`
      : `${LIVE_GW_URL}/health/v1/h5/agent/getCustomerManageInfo`
    return $apiPost(url, data)
  },
  // 签到记录-代理列表
  listFollow: data => post(`${LIVE_GW_URL}/health/v1/h5/sign/listFollow`, data),
  // 签到记录
  pageSignRecord: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/sign/pageSignRecord`, data),
  // 获取团队人数
  getTeamAgentNum: data =>
    get(`${LIVE_GW_URL}/health/v1/h5/agent/teamAgentNum`, data),
  // H5客户管理-解绑-换绑代理
  customerManageOperate: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/customerManageOperate`, data),
  // 获取代理网关信息
  postLiveAgentJudge: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/liveAgentJudge`, data),
  // H5代理详情-未观看用户
  getTopicNoViewList: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getTopicNoViewList`, data),
  // 代理员数据概况
  getTopicAgentStat: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/topicAgentStat`, data),
  // 代理员以上的等级概况
  tpAgentListSurvey: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/tpAgentListSurvey`, data),
  // 普通代理员基础数据查询
  topicAgentData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/topicAgentData`, data),
  // 代理员数据概况
  getAgentSelect: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentSelect`, data),
  // 当前企微好友是否绑定客户
  checkIsRelate: data =>
    get(
      `${LIVE_GW_URL}/health/v1/h5/agent/checkIsRelateWeComFriend`,
      data,
      false,
      {
        allRes: 1,
      }
    ),
  // 当前企微好友是否绑定客户
  customerInfo: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getCustomerManageInfo`, data),
  // 绑定已有客户
  bindCustomer: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/bindWeComFriend`,
      qs.stringify(data)
    ),
  // 健康观众列表导出
  postHealthUserListExport: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/healthUserListExport`, data),
  // H5客户管理列表导出
  exportCustomerManageInfo: data => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    const url = isStore
      ? `${LIVE_GW_URL}/health/v1/h5/store/manager/exportCustomerManageInfoByStore`
      : `${LIVE_GW_URL}/health/v1/h5/agent/exportCustomerManageInfo`
    return $apiPost(url, data)
  },
  // 代理推话题详情-代理员列表-导出观众明细
  tpAgentUserExport: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/tpAgentUserExport`, data),
  // 下载中心列表
  downloadList: data =>
    post(`${ZHIBO_URL}/v1/download/task/page`, data, false, {
      zhibo: true,
      allRes: true,
    }),
  downloadStatus: data =>
    post(`${ZHIBO_URL}/v1/download/task/download_status`, data, false, {
      zhibo: true,
    }),
  // 健康观众列表导出
  watchRecord: params => {
    const isStore = StoreController.isStore()
    let path = isStore
      ? '/health/v1/h5/store/manager/watchRecord'
      : '/health/v1/h5/agent/watchRecord'
    const $apiPost = isStore ? postStore : post
    return $apiPost(`${LIVE_GW_URL}${path}`, params, false)
  },
  agentLowerInfo: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/agentLowerInfo`,
      qs.stringify(data)
    ),

  // 获取代理支付钱包汇总
  getAgentPayStatistic: data =>
    post(`${BILL_API_URL}/api/UserCashLog/GetAgentPayStatistic`, data),

  // 获取代理支付充值记录
  getAgentPayChargeRecordPage: data =>
    post(`${BILL_API_URL}/api/UserCashLog/GetAgentPayChargeRecordPage`, data),

  // 代理支付充值余额
  agentPayRecharge: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/agentPayRecharge`, data),

  // 获取直播消耗明细
  getLiveRedPacketConDetail: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getLiveRedPacketConDetail`, data),

  // 用户消耗明细
  getUserRedPacketConDetail: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getUserRedPacketConDetail`, data),

  // 导出-获取直播消耗明细
  exportLiveRedPacketConDetail: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/exportLiveRedPacketConDetail`,
      data
    ),

  // 导出-用户消耗明细
  exportUserRedPacketConDetail: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/exportUserRedPacketConDetail`,

      data
    ),

  // 代理-我的页面
  getAgentMeInfo: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/getAgentMeInfo`,
      qs.stringify(data)
    ),

  // 代理支付红包
  addAgentPay: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentpay/addAgentPay`,
      qs.stringify(data)
    ),
  // 活动是否开启代理支付
  getTpAgentPayInfos: data =>
    post(`${LIVE_GW_URL}/generic/v1/h5/answer/getTpAgentPayInfos`, data),
  // 话题是否存在答题有礼
  getTpAnswerInfo: data =>
    post(`${LIVE_GW_URL}/generic/v1/h5/answer/getTpAnswerInfo`, data, false, {
      form: true,
    }),
  // 话题观看奖励活动信息
  getTpWatchingRewardInfos: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/getTpActInfo`, data),
  // 代理红包-观众领取明细
  getActAgentAudDataPage: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getActAgentAudDataPage`, data),
  // 观看奖励-观众领取明细
  getWatchingRewardActAgentAudDataPage: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/getRewardAudPage`, data),
  // 获取代理邀请明细
  getActAgentInviteDataPage: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getActAgentInviteDataPage`, data),
  // 获取观看奖励参与详情 列表
  getWatchRewardJoinDataPage: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/getWatchRewardJoinDataPage`, data),
  // 获取观看奖励参与详情 查询
  exportWatchRewardJoinData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/exportWatchRewardJoinData`, data),
  // 移除黑名单
  excludeUserMarketBlack: data =>
    post(`${FIXUP_URL}/api/v1/live_user/exclude_user_market_black`, data),
  // 获取观看奖励代理邀请明细
  getWatchingRewardActAgentInviteDataPage: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/getActAgentInviteDataPage`, data),
  // 获取代理活动数据总数据
  getActAgentSumData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getActAgentSumData`, data),
  // 获取代理观看奖励活动数据基础数据
  getWatchingRewardActAgentSumData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/getRewardSumData`, data),
  // 代理红包-观众领取明细导出
  exportActAgentAudData: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/exportActAgentAudData`,
      data,
      false
    ),
  // 观看奖励代理红包-观众领取明细导出
  exportWatchingRewardActAgentAudData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/act/exportActAgentAudData`, data, false),
  // 导出代理邀请明细
  exportActAgentInviteData: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/exportActAgentInviteData`,
      data,
      false
    ),
  // 导出观看奖励代理邀请明细
  exportWatchingRewardActAgentInviteData: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/act/exportActAgentInviteData`,
      data,
      false
    ),
  getZbRedPacketLimitConfig: data =>
    get(
      `${MARKET_URL}/api/v1/redpacket/GetZbRedPacketLimitConfig`,
      data,
      false
    ),
  // 代理红包-代理取消
  cancelAgentPay: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentpay/cancelAgentPay`,
      qs.stringify(data),
      false
    ),
  // 代理红包-获取设置代理
  getAgentPayRecord: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentpay/getAgentPayRecord`,
      qs.stringify(data),
      false
    ),
  // 获取直播分类
  getTopicCategory: data =>
    get(`${FIXUP_URL}/api/v1/wx/topic/get_topic_category`, data),
  // 待办用户
  pageTodoUser: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agentTask/pageTodoUser`, data),
  // 待办任务
  pageTodoTask: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agentTask/pageTodoTask`, data),
  // 用户评级
  userRateList: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agentTask/userRateList`, data),
  // 完成用户
  finishTodoUser: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agentTask/finishTodoUser`, data),

  /**
   * 商机管理
   */
  // 完成商机任务
  finishStep: data => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    const url = isStore
      ? `${LIVE_GW_URL}/health/v1/h5/store/manager/finishStep`
      : `${LIVE_GW_URL}/health/v1/h5/agentOpportunity/finishStep`
    return $apiPost(url, data)
  },

  // 所有商机
  listOpportunity: data => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    const url = isStore
      ? `${LIVE_GW_URL}/health/v1/h5/store/manager/listOpportunity`
      : `${LIVE_GW_URL}/health/v1/h5/agentOpportunity/listOpportunity`
    return $apiPost(url, data)
  },

  // 商机详情
  opportunityDetail: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentOpportunity/opportunityDetail`,
      data
    ),
  // 完成商机步骤的用户列表
  opportunityStepCustomer: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentOpportunity/opportunityStepCustomer`,
      data
    ),
  // 商机步骤详情
  opportunityStepDetail: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agentOpportunity/opportunityStepDetail`,
      data
    ),
  // H5客户管理-详情
  getCustomerDetail: (data, headers) => {
    const ua = navigator.userAgent
    let _header = {
      scene: headers ? headers.scene : undefined,
      lid: window.zbvd.zbid,
      Authorization: `Bearer ${getToken()}`,
    }
    try {
      // 取出ios版本（iOS12加上两个请求头参数 请求不了） 咨询过后端 这两个参数没啥吊用
      if (ua.indexOf('iPhone') > -1) {
        const version = ua.match(/OS (\d+)/)
        if (version && version[1] <= 13) {
          _header = {
            Authorization: `Bearer ${getToken()}`,
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
    return post(
      `${LIVE_GW_URL}/health/v1/h5/agent/getCustomerDetail`,
      data,
      false,
      {
        headers: _header,
        allRes: true,
      }
    )
  },
  // 代理推话题详情-代理员列表-详情
  tpAgentListDetail: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/tpAgentListDetail`, data),
  // 代理设置回放时间
  update_agent_topic_play_time: data =>
    post(`${LIVE_PALY_URL}/api/topic/update_agent_topic_play_time`, data, true),
  // 查询话题回放时间
  get_topic_play_time: data =>
    get(`${LIVE_PALY_URL}/api/topic/get_topic_play_time`, data),
  // 代理-门店统计-获取自己以及下级代理绑定的门店
  getLowerAgentStoreInfoOneSelf: data => {
    const isStore = StoreController.isStore()
    const HeaderConfig = isStore ? StoreController.apiHeaderConfig() : {}
    return post(
      `${LIVE_GW_URL}/health/v1/h5/agent-data/getLowerAgentStoreInfoOneSelf`,
      data,
      false,
      HeaderConfig
    )
  },
  // 代理-门店信息
  getStoreSummaryInfo: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent-data/getStoreSummaryInfo`,
      qs.stringify(data)
    ),
  // 客户码校验权限
  getCustomerCodeState: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/getCustomerCodeState`, data),
  // 代理绑定客户
  setAgentBindCus: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/customer/agentBindCus`, data),
  // 代理中心 获取用户团队负责人信息
  getTeamLeaderInfo: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/team/getTeamLeaderInfo`, data),
  // 代理中心 获取用户团队负责人信息
  switchIdentity: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/team/switchIdentity`, data),
  /** 代理-团队数据导出 */
  exportTeamAgentData: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/team/exportTeamAgentData`, data),
  /** 代理-团队数据 */
  listTeamAgent: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/team/listTeamAgent`, data, false),
  // 代理中心 获取上级角色列表
  inviteAgentOption: data =>
    post(`${LIVE_GW_URL}/health/v1/h5/agent/inviteAgentOption`, data),

  // 代理中心-获取门店直播间id（用于判断当前直播间下是否还存在门店直播间）
  getStoreZbIdApi: data =>
    get(`${LIVE_GW_URL}/health/v1/h5/agent/getStoreZbId`, data),

  // 门店直播间-代理中心话题列表(分页)
  getStoreAgentCenterTopicListApi: data =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/getStoreAgentCenterTopicList`,
      data
    ),
}

export const listColumn = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/listColumn`, data)
export const listUserColumn = data => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/listUserColumn`,
        data
      )
    : post(`${LIVE_GW_URL}/health/v1/h5/column/listUserColumn`, data)
}
export const pagePeriod = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/pagePeriod`, data)
export const pagePeriodTeam = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/pagePeriodTeam`, data)
export const liveColumnJudge = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/liveColumnJudge`, data)
// 档期概况
export const periodOverview = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodOverview`, data)
// 档期任务列表
export const periodTaskPage = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskPage`, data)
// 档期任务-详情
export const periodTaskDetail = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskDetail`, data)
// 推广概况
export const promotionOverview = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionOverview`, data)
// 代理任务分析
export const promotionAgentPage = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionAgentPage`, data)
// 代理任务分析-详情
export const promotionAgentDetail = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionAgentDetail`, data)
// 代理信息
export const promotionAgentInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionAgentInfo`, data)
// 推广明细概况
export const promotionDetailOverview = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionDetailOverview`, data)
// 推广任务分析
export const promotionTaskPage = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionTaskPage`, data)
// 推广任务分析-明细
export const promotionTaskDetail = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionTaskDetail`, data)
// 任务概况
export const periodTaskOverview = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskOverview`, data)
// 任务学员
export const periodTaskUserPage = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskUserPage`, data)
// 任务学员详情
export const periodTaskUserDetail = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  const url = isStore
    ? `${LIVE_GW_URL}/health/v1/h5/store/manager/periodTaskUserDetailByStore`
    : `${LIVE_GW_URL}/health/v1/h5/column/periodTaskUserDetail`
  return $apiPost(url, data)
}
// 任务学员导出
export const periodTaskUserExport = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskUserExport`, data)
// 用户观看栏目
export const userWatchColumn = data => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/userWatchColumn`,
        data
      )
    : post(`${LIVE_GW_URL}/health/v1/h5/column/userWatchColumn`, data)
}
// 档期任务导出
export const periodTaskExport = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskExport`, data)
// 推广任务分析-导出
export const promotionTaskExport = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionTaskExport`, data)
// 代理任务分析导出
export const promotionAgentExport = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/promotionAgentExport`, data)
// 小程序分享二维码
export const MiniQrCodeAndLink = data =>
  get(`${WechatApp}/api/ManageWxMini/MiniQrCodeAndLink`, data)
export const getMiniProQrCode = data =>
  get(`${WechatApp}/api/WxMini/MiniProQrCode`, data)

/**
 * 接入代理会员营销
 */
// 会员分享链接判断
export const getLinkUserFollowInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-member/getLinkUserFollowInfo`, data)
// 注册会员
export const registerCus = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/customer/registerCus`, data)
// 会员管理
export const memberPage = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-member/memberPage`, data)
// 获取会员等级全局配置
export const getGlobalConfig = data =>
  get(`${LIVE_GW_URL}/marketing/api/MemberLevel/getGlobalConfig`, data)
// 会员管理-导出
export const exportMemberInfo = data =>
  post(`${LIVE_GW_URL}/marketing/api/MemberLevel/exportMemberInfo`, data)
// 会员列表导出
export const exportMyMemberList = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-member/exportMyMemberList`, data)
// 会员详情
export const memberDetail = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-member/memberDetail`, data)
// 编辑会员详情
export const EditMemberCardData = data =>
  post(`${LIVE_GW_URL}/marketing/api/MemberLevel/EditMemberCardData`, data)
// 获取会员邀请信息
export const getMemberInviteInfo = data =>
  get(`${LIVE_GW_URL}/marketing/api/MemberLevel/getMemberInviteInfo`, data)
// 会员礼包送红包-领取红包
export const receiveRedPacket = data =>
  post(`${LIVE_GW_URL}/marketing/api/MemberLevel/receiveRedPacket`, data)
// 升降级新模式是否可以灰度
export const upDownModeSwitchIsGray = data =>
  get(
    `${LIVE_GW_URL}/marketing/api/ManageMemberLevelService/upDownModeSwitchIsGray`,
    data
  )
// 会员审核
export const memberAudit = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-member/memberAudit`, data)
// 直播间获取会员等级项
export const getMemberLevelItemList = data =>
  get(
    `${homeminiToLiveGw()}/api/ManageMemberLevelService/GetMemberLevelItemList`,
    data
  )
// 会员等级操作
export const agentAdminOperateLevel = data =>
  post(
    `${homeminiToLiveGw()}/api/ManageMemberLevelService/AgentAdminOperateLevel`,
    data
  )

/**
 * 门店
 */
// 门店列表
export const getStoreList = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/getStoreList`, data)

// 代理绑定门店
export const agentBindStore = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/bindStore`, data)

// 区域列表数据
export const getCommonAreaList = data =>
  post(`${SHOP_URL}/api/store/getcommonarealist`, data)
// 获取分佣角色
export const getUserDivideIntoRole = data =>
  get(`${SHOP_URL}/api/v1/wx/HealthDivideInto/GetUserDivideIntoRole`, data)

// 获取用户账户信息
export const getUserAccInfo = data =>
  post(`${LIVEPAY_URL}/LianLian/api/GetUserAccInfo`, data)

// 去开户
export const openacctPageApplyRegInfo = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.commonParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${LIVEPAY_URL}/LianLian/api/OpenacctPageApplyRegInfo`, data)
}

/**
 * * 获取用户账户信息
 * * data.status: 账户状态枚举
 * * 状态 -1:删除状态 0:默认未申请，1:已保存资料，2:已提交申请到连连等待验证，3:提交资料连连失败，4:审核中，5:审核失败，6:审核成功
 */
export const getrealacctinfo = (data, isloading = false) => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.getrealacctinfoParams(data)
  }
  const $apiPost = isStore ? getStore : get
  return $apiPost(
    `${LIVEPAY_URL}/lianlianaccp/api/v1/wx/getrealacctinfo`,
    data,
    isloading,
    {
      allRes: true,
    }
  )
}
/**
 * * 获取用户账户信息
 * * data.status: 账户状态枚举
 * * 状态 -1:删除状态 0:默认未申请，1:已保存资料，2:已提交申请到连连等待验证，3:提交资料连连失败，4:审核中，5:审核失败，6:审核成功
 */
export const getYeeRealacctinfo = (data, isloading = false) => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.getrealacctinfoParams(data)
  }
  const $apiPost = isStore ? getStore : get
  return $apiPost(
    `${LIVEPAY_URL}/yee/api/wx/getrealacctinfo`,
    data,
    isloading,
    {
      allRes: true,
    }
  )
}

// 获取验证码
export const get_supplier_phone_login_smscode = data =>
  get(`${FIXUP_URL}/api/v1/SMS/get_supplier_phone_login_smscode`, data)

// 供应商登录
export const supplier_code_login = data =>
  post(
    `${SHOP_URL}/api/v1/wx/healthdivideinto/supplier_code_login`,
    data,
    true,
    { form: 1 }
  )

// 版权方登录
export const copyright_manager_code_login = data =>
  post(
    `${SHOP_URL}/api/v1/wx/healthdivideinto/copyright_manager_code_login`,
    data,
    true,
    { form: 1 }
  )

// 获取代理员汇总数据
export const getAgentSummaryData = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-data/agentSummaryData`, data, false)

export const checkUserIspay = data =>
  get(`${LIVE_PALY_URL}/api/auth/check_user_ispay`, data, false)

// 强制授权微信unid灰度
export const unidGray = data =>
  get(`${LIVE_PALY_URL}/api/auth/check_user_ispay`, data, false)

// H5-答题记录(包含答题有礼和答题红包)
export const getAnswerRecordByUser = data => {
  const isStore = StoreController.isStore()
  const storeId = StoreController.storeId()
  if (isStore) data.storeId = storeId
  return isStore
    ? post(
        `${LIVE_GW_URL}/generic/v1/h5/answer/getStoreAnswerRecordByUser`,
        qs.stringify(data),
        false,
        isStore ? StoreController.apiHeaderConfig() : {}
      )
    : post(
        `${LIVE_GW_URL}/generic/v1/h5/answer/getAnswerRecordByUser`,
        qs.stringify(data)
      )
}

// 用户答题有礼详情记录
export const getAnswerRecordDetailByUser = data =>
  post(
    `${LIVE_GW_URL}
/generic/v1/h5/answer/getAnswerRecordDetailByUser`,
    qs.stringify(data)
  )

// 获取用户某个红包答题记录
export const getRedpacketAnswerLogDetail = data =>
  post(
    `${MARKET_URL}/api/v1/redpacket/getredpacketanswerlogdetail`,
    data,
    false
  )
/**
 * 群详情
 */
// 企微群-获取企微群绑定话题信息
export const getCwxGroupBindTopic = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/getCwxGroupBindTopic`, data, false, {
    allRes: true,
  })

// 企微-分页获取群成员信息
export const pageCwxGroupCustomer = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/pageCwxGroupCustomer`, data)

// 企微-群详情切换直播
export const switchTopicApi = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/saveCwxGroupBindTopic`, data)

// 商品推广分类列表
export const classlist = data => get(`${SHOP_URL}/api/product/classlist`, data)

// 代理商品列表
export const agentProducts = data =>
  post(`${SHOP_URL}/api/v2/product/agent_products`, data)

// 代理页面收藏商品列表（代理员收藏）
export const agentProductsBookmark = data =>
  post(`${SHOP_URL}/api/v2/product/agent_products_bookmark`, data)

/** 代理商品列表 */
export const agentProductsGw = data =>
  get(`${LIVE_GW_URL}/shop/v3/H5/shop/product/getProducts`, data)

// 收藏商品
export const favoriteProduct = data =>
  post(`${LIVE_GW_URL}/shop/v3/H5/shop/product/favoriteProduct`, data)
// 获取用户跟进人信息
export const getFollowInfo = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/customer/getFollowInfo`, data)
export const getTopicFollowInfo = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/customer/getTopicFollowInfo`, data)

export const queryRechargeValue = data =>
  post(`${LIVEPAY_URL}/indepay/api/query_recharge_value`, data)

/**
 * 添加客户跟进
 * @param {
  "content": "",
  "imgList": "",
  "userId": 0,
  "zbId": 0
}
 * @returns {*|Promise|Promise<unknown>}
 */
export const addFollowUp = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  const url = isStore
    ? `${LIVE_GW_URL}/health/v1/h5/store/manager/addFollowUp`
    : `${LIVE_GW_URL}/health/v1/h5/agent/addFollowUp`
  $apiPost(url, data)
}

/**
 * 添加客户跟进
 * @param {
  "pageIndex": 1,
  "pageSize": 10,
  "userId": 0,
  "zbId": 0
}
 * @returns {*|Promise|Promise<unknown>}
 */
export const pageFollowUp = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/pageFollowUp`, data)

/**
 * * 代理发货单相关接口
 * * ${BILL_API_URL}/api/AgentDeliveryNote/
 */
/**
 * * 获取发货单列表 （自营模式）
 * @pageIndex integer
 * @pageSize integer
 * @state integer 状态 null-全部 0-待配送 1-配送中 2-已送达
 * @zbId integer
 */
export const GetDeliveryNoteList = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = { ...data, from: 4 }
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${BILL_API_URL}/api/AgentDeliveryNote/GetDeliveryNoteList`,
    data
  )
}

/**
 * * 确认送达
 * @zbId integer
 * @id integer
 */
export const ConfirmDeliveredInput = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = { ...data, from: 4 }
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${BILL_API_URL}/api/AgentDeliveryNote/ConfirmDeliveredInput`,
    isStore
      ? StoreApiController.commonFromParams({
          ...data,
          ...StoreController.billApiStoreParams(),
        })
      : data
  )
}

/**
 * * 获取发货单详情
 * @zbId integer
 * @topicId integer
 * @id integer
 */
export const GetDeliveryNoteDetail = data =>
  post(`${BILL_API_URL}/api/AgentDeliveryNote/GetDeliveryNoteDetail`, data)

/**
 * * 获取发货单商品列表
 * @zbId integer
 * @productName string
 * @id integer
 */
export const GetDeliveryProductList = data =>
  post(`${BILL_API_URL}/api/AgentDeliveryNote/GetDeliveryProductList`, data)

/**
 * * 导出发货单商品列表-直接下载文件
 * @zbId integer
 * @productName string
 * @id integer
 */
export const ExportDeliveryProduct = data =>
  post(`${BILL_API_URL}/api/AgentDeliveryNote/ExportDeliveryProduct`, data)

/**
 * * 获取物流信息（采购模式）（自营模式）
 * @id Integer @deliveryNo String @deliveryName String
 */
export const GetProcurelogistics = data =>
  get(
    `${SHOP_URL}/api/zbdeliveryprocure/getlogistics?storeId=${data.storeId}&deliveryNo=${data.deliveryNo}&deliveryName=${data.deliveryName}`,
    {}
  )

/**
 * * 获取物流信息 （自营模式）
 * @id Integer @deliveryNo String @deliveryName String
 */
export const Getlogistics = data =>
  get(
    `${SHOP_URL}/api/zbdeliverynote/getlogistics?zbId=${data.zbId}&id=${data.id}&deliveryNo=${data.deliveryNo}&deliveryName=${data.deliveryName}`,
    {}
  )

/**
 * * 获取发货单列表  （采购模式）
 * @pageIndex integer
 * @pageSize integer
 * @state integer 状态 null-全部 0-待配送 1-配送中 2-已送达
 * @zbId integer
 * @selfTakeStoreId integer 门店id
 */
export const GetDeliveryProcureList = data => {
  const isStore = StoreController.isStore()
  const params = {
    ...data,
    ...StoreController.billApiStoreParams(),
  }
  return isStore
    ? postStore(
        `${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryProcureList`,
        StoreApiController.GetDeliveryProcureListParams(params)
      )
    : post(
        `${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryProcureList`,
        data
      )
}

/**
 * * 选品订单 确认送达
 * @id integer
 */
export const ConfirmSupplyOrderReceive = data =>
  post(
    `${LIVE_GW_URL}/product/userlive/v1/h5/order/confirmSupplyOrderReceive`,
    data
  )

/**
 * * 确认送达 （采购模式）
 * @zbId integer
 * @id integer
 */
export const ConfirmDelivered = data => {
  const isStore = StoreController.isStore()
  const storeId = StoreController.storeId()
  if (isStore) {
    data = StoreApiController.ConfirmDeliveredParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${BILL_API_URL}/api/AgentDeliveryProcure/ConfirmDelivered`,
    data
  )
}
export const ConfirmDeliveredV2 = data => {
  const isStore = StoreController.isStore()
  const storeId = StoreController.storeId()
  if (isStore) {
    data = StoreApiController.ConfirmDeliveredParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${BILL_API_URL}/api/AgentDeliveryProcure/v2/ConfirmDelivered`,
    data
  )
}

/**
 * * 查询物流信息 （采购模式）
 * @id Integer @deliveryNo String @deliveryName String
 */
export const GetDeliveryInfo = data => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryInfo`,
        StoreApiController.commonFromParams({
          ...data,
          ...StoreController.billApiStoreParams(),
        })
      )
    : post(`${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryInfo`, data)
}

/**
 * * 查询物流信息 （采购模式）
 * @id Integer @deliveryNo String @deliveryName String
 */
export const GetDeliveryInfoV2 = data => {
  const isStore = StoreController.isStore()
  return isStore
    ? postStore(
        `${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryInfo`,
        StoreApiController.commonFromParams({
          ...data,
          ...StoreController.billApiStoreParams(),
        })
      )
    : post(`${BILL_API_URL}/api/AgentDeliveryProcure/V2/GetDeliveryInfo`, data)
}

// 获取发货单模式配置
export const GetDeliveryModel = data =>
  get(`${BILL_API_URL}/api/AgentDeliveryProcure/GetDeliveryModel`, data)

/**
 * * 选品订单 下载接口
 * @id integer
 */
export const ExportDistribuOreder = data =>
  post(`${LIVE_GW_URL}/product/userlive/v1/h5/order/exportSupplyOrder`, data)

/**
 * * 导出发货单商品列表-直接下载文件 （采购模式）
 * @zbId integer
 * @productName string
 * @id integer
 */
export const ExportOrder = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  $apiPost(
    `${BILL_API_URL}/api/AgentDeliveryProcure/ExportOrder`,
    isStore
      ? StoreApiController.StoreExportOrderParams({
          ...data,
          ...StoreController.billApiStoreParams(),
        })
      : data
  )
}

// 获取角色详情
export const divide_into_role_details = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.divideIntoRoleDetailsParams(data)
  }
  const $apiPost = isStore ? getStore : get
  return $apiPost(
    `${SHOP_URL}/api/v1/wx/healthdivideinto/divide_into_role_details`,
    data
  )
}
/**
 * * 代理导出团队数据
 *
 */
export const agentExportGroup = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/column/periodTaskUserExport`, data)

// 代理修改信息
export const updateAgentInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/updateAgentInfo`, data)

// 代理提现
export const agentWithdraw = data =>
  post(`${LIVEPAY_URL}/IndePay/api/IndePayDeductCashH5`, data)

// 第三方钱包余额查询
export const getThirdPartyWalletBalance = data =>
  get(`${LIVEPAY_URL}/IndePay/api/thirdwalletamounth5`, data)

/**
 * 激活代理
 * @param {
  "zbId": 0
}
 * @returns {*|Promise|Promise<unknown>}
 */
// 获取角色详情
export const activatedAgent = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/register/activatedAgent`, data)

// 获取用户角色权限
export const getUserRoleSetting = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/role/getUserRoleSetting`, data)

// 获取当前咨询代理的门店信息
export const getConsultUserStoreInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/role/getConsultUserStoreInfo`, data)

// 获取门店客服配置
export const getCustomerServiceSetting = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/role/getCustomerServiceSetting`, data)

// 获取第三方客服配置
export const getCustomerServiceConfig = data =>
  get(`${LIVE_INTERFACE_URL}/custom/v1/thirdSupport/h5/getSetting`, data)

// 获取第三方客服链接
export const getThirdSupportLink = data =>
  get(`${LIVE_INTERFACE_URL}/custom/v1/thirdSupport/getThirdSupportLink`, data)

// 消费榜-消费金额榜&消费订单榜
export const pageConsumerRank = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-data/pageConsumerRank`, data)

// 消费榜-消费金额榜&消费订单榜-数据导出
export const exportConsumerRank = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-data/exportConsumerRank`, data)
// 获取代理参与红包设置信息
export const getAgentJoinRedPacketSetting = data =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/act/getAgentJoinRedPacketSetting`,
    qs.stringify(data)
  )

// 获取代理参与红包设置信息
export const saveAgentJoinRedPacketSetting = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/act/saveAgentJoinRedPacketSetting`, data)

// 提货单查询
export const getAgentTodOrderList = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetAgentTodOrderList`, data)

// 提货单验证码验证
export const codeVerify = data =>
  post(`${BILL_API_URL}/api/AgentOrder/CodeVerify`, data)

// 提货单验证码验证结果
export const getCodeVerifyResult = data =>
  get(`${BILL_API_URL}/api/AgentOrder/GetCodeVerifyResult`, data)

// 提货单导出
export const exportAgentToOrderTask = data =>
  post(`${BILL_API_URL}/api/AgentOrder/ExportAgentToOrderTask`, data)

// 提货单导出任务查询
export const getOrderExportTask = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetOrderExportTask`, data, true)
// 获取门店详情信息
export const getStoreInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/getStoreDetail`, data)
// H5获取门店代理接口
export const getSuperiorStore = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/getSuperiorStore`, data)

// 更新申请门店信息
export const updateApplyStoreInfo = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/register/updateApplyStoreInfo`, data)

// 代理直播间功能灰度
export const agentIsGray = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/isBusinessWhiteZbId`, data)

// 缓存生成的分享链接
export const cacheShareLink = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/cacheShareLink`, data)

// 代理端获取商城分享配置
export const getAgentProductShareConfig = data =>
  post(`${LIVE_GW_URL}/shop/v3/H5/shop/product/getStoreSetting`, data)
// 代理绑定客户
export const agentBindCus = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/customer/agentBindCus`, data)
// 是否开启了check_unionid
export const checkUnionid = data =>
  get(`${LIVE_PALY_URL}/api/auth/check_unionid`, data, false)

// 企微绑定外部联系人
export const BindExternalUserId = data =>
  post(`/liveajax/BindExternalUserId`, data, false)

// 外部联系人绑定查询授权成功后信息
export const cwxAuthInfo = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/customer/cwxAuthInfo`, data)

// 是否开通多账户
export const IsMultipleAccounts = data =>
  post(`${BILL_API_URL}/api/HealthDivideInto/IsMultipleAccounts`, data)

// 获取账户列表
export const GetWxUserLianRegInfoList = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.GetWxUserLianRegInfoListParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${BILL_API_URL}/api/HealthDivideInto/GetWxUserLianRegInfoList`,
    data
  )
}

// 设置默认账户
export const IsDefaultMultipleAccounts = data =>
  post(`${BILL_API_URL}/api/HealthDivideInto/IsDefaultMultipleAccounts`, data) // 获取门店客服配置

// 获取店铺
export const getselftakestoredetail = data =>
  get(`${SHOP_URL}/api/store/getselftakestoredetail`, data)

// 转账到总部
export const createtransfercash = params => {
  const isStore = StoreController.isStore()
  if (isStore) {
    params = StoreApiController.commonParams(params)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${LIVEPAY_URL}/lianlianaccp/api/v1/wx/createtransfercash`,
    params
  )
}
// 转账到总部--易宝
export const yeeCreatetransfercash = params => {
  const isStore = StoreController.isStore()
  if (isStore) {
    params = StoreApiController.commonParams(params)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${LIVEPAY_URL}/yee/api/wx/createtransfercash`, params)
}

// 答题有礼功能-用户活动数据查询
export const userActivityDataQuery = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    isStore
      ? `${LIVE_GW_URL}/generic/v1/h5/answer/getStoreAnswerRecordActivityData`
      : `${LIVE_GW_URL}/generic/v1/h5/answer/getAnswerRecordActivityData`,
    data
  )
}

// 客户详情权限判断
export const getCustomerState = data =>
  get(`${LIVE_GW_URL}/health/v1/h5/cwxGroup/getCustomerState`, data)

// 开户信息获取
export const getRegInfo = token =>
  get(
    `${LIVEPAY_URL}/LianLian/api/wx/WxRegInfoByOpenToken?token=${token}`,
    null,
    true,
    {
      allResolve: true,
    }
  )
// 开户图片上传
export const uploadImg = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxMediaUpload`, data)
// 开户秘密获取随机因子
export const getSecretFactor = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxCreateRandom`, data)
// 开户手机验证码
export const wxApplyVerifyCode = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxApplyVerifyCode`, data)
// 银行预留手机号验证码

export const wxApplyRegInfoVerifyCode = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxApplyRegInfoVerifyCode`, data)
// 开户提交
export const wxApplyRegInfo = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxApplyRegInfo`, data)
// 个人银行验证码校验
export const wxOpenacctVerifyIndividual = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxOpenacctVerifyIndividual`, data)
// 企业法人银行验证码校验
export const wxOpenacctVerifyEnterprise = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/WxOpenacctVerifyEnterprise`, data)

export function saveGroupRemark(params) {
  return post(
    `${SCRM_URL}/open-api/v1/cwx/customer_group/saveGroupRemark`,
    params,
    false
  )
}
// 申请密码控件Token（连连新密码控件）
export const applypasswordelement = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.commonParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${LIVEPAY_URL}/LianLian/api/wx/applypasswordelement`, data)
}

// 代理福袋数据
// 获取代理福袋列表数据
export const getLuckyBagList = data =>
  post(`/marketing/wx/v1/lucky/bag/agent_topic_lucky_bag_list`, data)
// 获取福袋详情中中奖人员列表
export const getLuckyUserList = data =>
  post(`/marketing/wx/v1/lucky/bag/agent_topic_lucky_bag_detail`, data)
// 福袋中奖人员导出
export const exportLuckyBagData = (data, userid) =>
  post(
    `/marketing/wx/v1/lucky/bag/create_agent_lucky_bag_winner_task?downUserId=${userid}`,
    data
  )
// 核销记录导出（商品）
export const exportVerificationRecord = data =>
  post(`${SHOP_URL}/api/v1/wx/verify/verified_list_export`, data)

// 核销记录导出（优惠券）
export const exportCouponVerificationRecord = data =>
  post(`${MARKET_URL}/api/v1/coupon/exportcouponverifylog`, data)

// 下载中心核销记录导出列表
export const getVerificationRecordList = data =>
  post(`${SHOP_URL}/api/v1/wx/verify/get_verified_list_export`, data, true)

// 代理中心-获取代理以及下级代理的门店列表
export const getAgentStoreList = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent-data/pageLowerAgentStoreList`, data)

// 获取会员数据统计
export const queryMemberStatistics = data =>
  post(`${LIVE_GW_URL}/marketing/api/MemberLevel/queryMemberStatistics`, data)
// 获取代理直播间信息
export const getUserBelong = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/get_user_belong`, data)

// 获取用户对应话题参与观看奖励记录
export const getWatchRewardByTopic = data =>
  post(
    `${LIVE_GW_URL}/datalive/v1/admin/watchreward/user_join_act_topic_list`,
    data
  )

// 获取用户参与观看奖励记录
export const getWatchRewardByUser = data =>
  post(`${LIVE_GW_URL}/datalive/v1/admin/watchreward/user_join_act_list`, data)

// 设置缓存信息
export const setCacheInfo = data => {
  return postStore(
    `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/setCacheInfo`,
    data
  )
}

// 获取缓存信息
export const getCacheInfo = data => {
  return get(`${LIVE_GW_URL}/health/v1/h5/store/manager/getCacheInfo`, data)
}
// 获取开户配置
export const getOpenAccountConfig = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.commonParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${LIVEPAY_URL}/lianLian/api/wx/get_openacc_config`, data)
}
// 保存代理二维码MD5加密信息
export const setRecruitValidity = ({ validityKey, zbId }) => {
  return post(
    `${LIVE_GW_URL}/health/v1/h5/agent/setRecruitValidity?validityKey=${validityKey}&zbId=${zbId}`
  )
}

// 获取H5分佣子商户风险统计
export const get_h5_divideinto_submch_stat = data =>
  post(`${LIVEPAY_URL}/lianlianaccp/api/get_h5_divideinto_submch_stat`, data)

// 获取H5分佣子商户风险统计列表
export const get_h5_divideinto_submch_riskstat_list = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${LIVEPAY_URL}/lianlianaccp/api/get_h5_divideinto_submch_riskstat_list`,
    data
  )
}

// 确认子商户号
export const comfirm_submch = data =>
  post(`${LIVEPAY_URL}/lianlianaccp/api/h5_divideinto_comfirm_submch`, data)

// 获取H5分佣子商户风险统计 易宝
export const get_Yee_divideinto_submch_stat = data =>
  post(`${LIVEPAY_URL}/yeepay/api/get_h5_divideinto_submch_stat`, data)

// 获取H5分佣子商户风险统计列表 - 易宝
export const get_Yee_divideinto_submch_riskstat_list = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  return $apiPost(
    `${LIVEPAY_URL}/yeepay/api/get_h5_divideinto_submch_riskstat_list`,
    data
  )
}

// H5分佣子商户确认
export const h5_divideinto_comfirm_submch = data =>
  post(`${LIVEPAY_URL}/lianlianaccp/api/h5_divideinto_comfirm_submch`, data)

// 获取等级变更日志列表
export const getMemberLevelModifyLogList = data =>
  post(
    `${LIVE_GW_URL}/marketing/api/MemberLevel/getMemberLevelModifyLogList`,
    data,
    true
  )

// 获取UpDownMode
export const getUpDownMode = data =>
  get(`${LIVE_GW_URL}/marketing/api/MemberLevel/getUpDownMode`, data, true)
// 发货单配置
export function getwxdeliveredconfig(params) {
  return get(
    `${SHOP_URL}/api/v1/wx/zbdeliverynote/getwxdeliveredconfig`,
    params,
    false
  )
}

// 供应商详情
export function get_agent_view_supplier(params) {
  return post(
    `${SHOP_URL}/api/v1/wx/healthdivideinto/get_agent_view_supplier`,
    params,
    false
  )
}

// H5代理码判断
export const agentCodeJudge = data =>
  post(`${LIVE_GW_URL}/health/v1/h5/agent/agentCodeJudge`, data)

// 查询单场直播观看奖励代理红包列表
export const getTopicWatchRewardAgentData = data =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/act/getTopicWatchRewardAgentData`,
    data,
    false
  )

//
export const get_agent_transfer_account_list = data =>
  get(
    `${SHOP_URL}/api/v1/wx/HealthDivideInto/get_agent_transfer_account_list`,
    data,
    true
  )
// 获取代理表单协议正文数据
export const getAgentFormData = data =>
  post(
    `${LIVE_GW_URL}/health/v1/h5/agent/getAgentElectronicAgreement`,
    data,
    false
  )
// 自助核销记录导出（商品）
export const exportGoodsRecord = data =>
  post(`${SHOP_URL}/api/verify/selfverifyrecord/ExportSelfVerifyRecords`, data)

// 自助核销记录导出（优惠券）
export const exportCouponRecord = data =>
  post(
    `${MARKET_URL}/api/v1/coupon/selfVerifyRecord/ExportCouponSelfVerifyLog`,
    data
  )

// 获取快捷支付类型 0：连连 1：易宝
export const wxGetThirdType = data => {
  return get(`${LIVEPAY_URL}/yee/api/wx/WxGetThirdType`, data)
}
// 门店商品的推广文案列表
export const getPromotionCopyList = data =>
  get(`${LIVE_GW_URL}/shop/v3/H5/shop/product/promotionCopyList`, data, false)
// 营业执照,身份证识别
/**
 * @param {
 *  action:"", // 身份证识别为：IDCardOCR（身份证）,BizLicenseOCR（营业执照）
 *  image_url:""
 * } data
 * @returns
 */
export const get_ocr = data =>
  post(`${LIVEPAY_URL}/Ocr/api/get_ocr`, data, false)

export const getMpQrcode = data => post(`${wxHost}/live/GetMiniQRSrc`, data)

// 开户激活申请，获取验证码
export const getActiveCode = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/OpenacctActivateApply`, data)
// 开户激活验证
export const handleActive = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/OpenacctActivateVerify`, data)
// 获取开户意愿确认链接
export const getOpenAccountWillUrl = data =>
  post(`${LIVEPAY_URL}/LianLian/api/wx/LianLianPayUserInfoQuery`, data)

// 连连 撤销提现
export const cancellivedraw_lianlian = data =>
  post(`${LIVEPAY_URL}/lianlianpayresource/api/wx/wxactioncanceldraw`, data)
// 易宝 撤销提现
export const cancellivedraw_yee = data =>
  post(`${LIVEPAY_URL}/yee/api/wx/wxactioncanceldraw`, data)
